import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAlert } from 'react-alert';
import {
  fetchPerguntasConselhoMunicipal, fetchEnquetesPergunta, fetchEnquetesRespostas, postEnquetesVotar,
} from '../../api/endpoints';
import { resetarModais, selectModal, fecharModalEnquete } from '../../app/slices/modalSlice';
import { selectLogin } from '../../app/slices/loginSlice';
import Botao from '../../components/Botao/Botao';
import AppHeader from '../../components/AppHeader/AppHeader';
import {
  Alerta, Centro, ContainerJanela, Divisor, FormFooter, LabelEnquete, Linha,
  AppBody, AppFragment, Container, Interno, Titulo,
} from '../../styles/base';
import Carregar from '../../components/Carregar/Carregar';
import { LinhaForm } from '../../components/FormControl/FormControlEstilo';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';

const defaultValues = {
  IdEnquete: '',
  IdResposta: '',
};

const IniciarEnquete = () => {
  const dadosModal = useSelector(selectModal);
  const [pergunta, setPergunta] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [listaRespostas, setListaRespostas] = useState(null);
  const [aberto, setAberto] = useState(false);
  const dispatch = useDispatch();
  const dadosLogin = useSelector(selectLogin);
  const alert = useAlert();

  const respostasDaDeterminadaPergunta = (perg) => {
    const respostas = listaRespostas && listaRespostas.filter((resposta) => resposta.IdEnquete === perg.Id);
    return respostas;
  };

  const ExibiLoader = () => {
    setCarregando(true);
    setTimeout(() => {
      setCarregando(false);
    }, 300);
    Promise.all([
      fetchEnquetesPergunta(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPergunta(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });
    setAberto(false);
    return true;
  };

  const [values, setValues] = useState(defaultValues);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  const perguntas2 = pergunta.length > 0 && pergunta.filter((perg) => respostasDaDeterminadaPergunta(perg) && respostasDaDeterminadaPergunta(perg).length > 0);

  useEffect(() => {
    Promise.all([
      fetchEnquetesPergunta(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPergunta(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });
  }, [dadosLogin]);

  window.onload = () => {
    dispatch(resetarModais());
  };

  const realizarVoto = async (id) => {
    const resposta = await postEnquetesVotar({
      ...values,
      IdEnquete: id,
    });

    if (resposta.Error === 'Voce ja votou nessa enquete.' || resposta.Error === 'Você já votou nessa enquete.') {
      return alert.error('Você já votou nessa enquete.', { timeout: 5000 });
    }

    if (resposta.Error) {
      return alert.error('Por favor, selecione uma das alternativas para realizar o voto.', { timeout: 5000 });
    }

    setValues(defaultValues);

    ExibiLoader();

    Promise.all([
      fetchEnquetesPergunta(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPergunta(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });

    return alert.success('Voto computado.', { timeout: 5000 });
  };

  return (
    <AppFragment onKeyDown={(e) => {
      if (e.key === 'Escape') {
        dispatch(resetarModais());
      }
    }}
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <AppHeader />
      <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
        <Container>
          <Titulo>Enquetes</Titulo>

          <Divisor />

          {carregando && (
            <Carregar />
          )}

          {(perguntas2.length > 0) ? (
            perguntas2.map((perg) => (
              (
                <>
                  {(!pergunta || !listaRespostas) ? (<Carregar />) : (
                    <>
                      {pergunta.Message && !carregando ? (
                        <Centro>
                          <Divisor />

                          <Alerta>Não há nenhuma enquete disponível.</Alerta>
                        </Centro>
                      ) : (
                        <>
                          <b style={{ fontSize: 18 }}>{pergunta[0].Campo}</b>

                          <Divisor />

                          <form>
                            {listaRespostas && listaRespostas.filter((resposta) => resposta.IdEnquete === pergunta[0].Id).map((respostas) => (
                              <div key={respostas.Id}>
                                <LinhaForm>
                                  <LabelEnquete htmlFor={`inputResposta${respostas.Id}`}>
                                    <input
                                      type="radio"
                                      name="respostaEnquete"
                                      value={respostas.Id}
                                      id={`inputResposta${respostas.Id}`}
                                      onChange={() => setVal('IdResposta', respostas.Id)}
                                    />
                                    {' '}
                                    {respostas.Campo}
                                  </LabelEnquete>
                                </LinhaForm>

                                <Divisor />
                              </div>
                            ))}
                            {(listaRespostas.filter((resposta) => resposta.IdEnquete === pergunta[0].Id).length === 0) && (
                            <p>Nenhuma resposta cadastrada.</p>
                            )}
                          </form>

                          <Divisor />

                          <FormFooter>
                            <Botao
                              label="Votar"
                              onClick={() => realizarVoto(perg.Id)}
                            />
                          </FormFooter>
                        </>
                      )}

                    </>
                  )}

                  <Divisor />
                </>
              )
            ))) : ((!carregando) && <p>Não há enquetes disponíveis.</p>)}

        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarEnquete;
